import { match } from 'ts-pattern';
import { PositionType, PostConnectionType, PostSharingType } from '../__generated/model/index.js';
export const getBalustradeSectionPosts = (section, shape, maxPostDistance, useThinIntermediatePosts)=>{
    const sharedEndPost = section.postSharingType === PostSharingType.Last || section.postSharingType === PostSharingType.Both;
    const numberOfPosts = Math.floor(section.length / maxPostDistance) + 2;
    const postStep = section.length / (numberOfPosts - 1);
    const isOddNumberOfPosts = numberOfPosts % 2 === 1;
    const shouldUseThinIntermediatePosts = useThinIntermediatePosts && isOddNumberOfPosts;
    const posts = Array.from({
        length: numberOfPosts
    }, (_, j)=>j).flatMap((j)=>{
        const isOddPost = j % 2 === 1;
        const isThinIntermediatePost = shouldUseThinIntermediatePosts && isOddPost;
        const positionType = match(j).with(0, ()=>{
            return section.left.positionType;
        }).with(numberOfPosts - 1, ()=>{
            return section.right.positionType;
        }).otherwise(()=>{
            return match(isThinIntermediatePost).with(true, ()=>{
                return PositionType.ThinIntermediate;
            }).with(false, ()=>{
                return PositionType.Intermediate;
            }).exhaustive();
        });
        const slope = match(j).with(0, ()=>{
            return section.left.slope;
        }).with(numberOfPosts - 1, ()=>{
            return section.right.slope;
        }).otherwise(()=>{
            return 0;
        });
        const x = section.left.x + j * postStep;
        return {
            type: 'Post',
            key: `${section.key}_post_${j}`,
            deckItemId: shape.instance.entityId,
            positionType,
            shared: sharedEndPost && j === numberOfPosts - 1,
            x,
            y: section.height,
            slope
        };
    });
    return posts;
};
export const getBalustradeSectionStairPosts = (section, shape, maxPostDistance, goingDistance, riserDistance)=>{
    const sharedEndPost = section.right.connectionType === PostConnectionType.Shared;
    const numberOfPosts = Math.ceil(section.length / maxPostDistance) + 1;
    const numberOfSteps = Math.round(section.length / goingDistance) + 1;
    const numberOfStepsDiff = Math.round(numberOfSteps / numberOfPosts) + 1;
    const posts = Array.from({
        length: numberOfPosts
    }, (_, j)=>j).flatMap((j)=>{
        const directedIndex = section.reverse ? numberOfPosts - j - 1 : j;
        const y = match(directedIndex).with(0, ()=>{
            return section.height;
        }).with(numberOfPosts - 1, ()=>{
            if (!section.reverse && section.right.connectionType !== PostConnectionType.None) {
                return 0;
            }
            if (section.reverse && section.left.connectionType !== PostConnectionType.None) {
                return 0;
            }
            return riserDistance;
        }).otherwise(()=>{
            return section.height - numberOfStepsDiff * directedIndex * riserDistance;
        });
        const x = match(directedIndex).with(0, ()=>{
            return section.left.x;
        }).with(numberOfPosts - 1, ()=>{
            return section.right.x;
        }).otherwise(()=>{
            // this is magic constant to offset the mid stair post to fit well for Timber + Alu posts on the default 250/185 stairs, this will be improved later
            return numberOfStepsDiff * goingDistance * directedIndex - goingDistance / 2 + 28;
        });
        const positionType = match(j).with(0, ()=>{
            return section.left.positionType;
        }).with(numberOfPosts - 1, ()=>{
            return section.right.positionType;
        }).otherwise(()=>{
            return PositionType.AngledIntermediate;
        });
        return {
            type: 'Post',
            key: `${section.key}_post_${j}`,
            deckItemId: shape.instance.entityId,
            positionType,
            shared: sharedEndPost && j === numberOfPosts - 1,
            x,
            y,
            slope: section.slope
        };
    });
    return posts;
};

//# sourceMappingURL=posts.js.map